export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14787.cb47c638.jpg";